import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {IsEmptyString} from '../../defines/common.func';

export enum MP_RESULT {
  CANCEL,
  ERROR,
  OK,
}

export type MpConfig = {
  msg: string;
  title?: string;
  image?: string;
  btnOk?: string;
  btnError?: string;
  btnCancel?: string;
};

@Component({
  selector: 'app-msg-popup',
  templateUrl: './msg-popup.component.html',
  styleUrls: ['./msg-popup.component.scss']
})
export class MsgPopupComponent implements OnInit {
  @Input() config: MpConfig;
  @Output() clickBtn: EventEmitter<MP_RESULT>;

  IsEmptyString = IsEmptyString;
  MP_RESULT = MP_RESULT;

  constructor() {
    this.clickBtn = new EventEmitter<MP_RESULT>();
  }

  ngOnInit(): void {
  }

  onClose($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();

    if (this.config.btnCancel) {
      this.clickBtn.emit(MP_RESULT.CANCEL);
    }
    else if (this.config.btnOk) {
      this.clickBtn.emit(MP_RESULT.OK);
    }
    else if (this.config.btnError){
      this.clickBtn.emit(MP_RESULT.ERROR);
    }
    else {
      this.clickBtn.emit(MP_RESULT.OK);
    }
  }
}
